import { Configuration, LogLevel } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;
const apiClientId = import.meta.env.VITE_API_CLIENT_ID as string;

if (!tenantId || !clientId || !apiClientId) {
  console.warn('MSAL: Missing one or more environment variables (VITE_ENTRA_TENANT_ID, VITE_ENTRA_CLIENT_ID, VITE_API_CLIENT_ID)');
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) console.log(`[MSAL][${LogLevel[level]}]`, message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes required to call the backend API
export const apiScopes = [`api://${apiClientId}/access_as_user`];

// Login request — openid + profile gives us name and email in the token
export const loginRequest = {
  scopes: ['openid', 'profile', ...apiScopes],
};
